import axios from 'axios'
import axiosInstance from '../axiosInstance'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import getHeadersformdata from './getHeaderFormdata'
import { NotificationManager } from 'react-notifications'
import { HTTP_STATUS } from '../constants/httpstatus/HttpsStatus'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod'

//part List Action  
export const partListAction = (page, name, id, sort, column) => (dispatch, getState) => {

  const API_URL = localStorage.getItem('countryBackendUrl')
  const { sortColumn, sortDirection } = getState().partlistSort;
  const PAGE_SIZE = 15;

  let url = API_URL + Url.PART_LIST;
  const queryParams = [];

  if (id) queryParams.push(`vehicle_ids=${id}`);
  else if (name) queryParams.push(`vehicle_ids=""`);

  if (name) queryParams.push(`search=${name}`);
  if (page) queryParams.push(`page=${page}`, `page_size=${PAGE_SIZE}`);

  if (sort && column) {
    queryParams.push(`order_by=${column}`, `order=${sort}`);
  } else if (sortColumn && sortDirection) {
    queryParams.push(`order_by=${sortColumn}`, `order=${sortDirection}`);
  }

  url += `?${queryParams.join('&')}`;

  const options = {
    method: 'GET',
    headers: getHeaders(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS) {
      dispatch({ type: types.GET_PART_LIST, payload: resp })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//part list sorting
export const partListSort = (column, direction) => dispatch => {
  dispatch({ type: types.PART_LIST_SORT, payload: { column, direction } });
}

// Searched data of partlist Action
export const partlistSearchInput = (params = {}) => dispatch => {
  dispatch({ type: types.PART_LIST_SEARCH_INPUT, payload: params })
}


// partlist  Page data Action
export const partlistPageValue = (params = {}) => dispatch => {
  dispatch({ type: types.PART_LIST_PAGE_INPUT, payload: params })
}

// Create Part Post API

export const createpartAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.CRETAE_PART
  const options = {
    method: HTTP_METHOD.POST,
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.POST_CRETAE_PART, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === HTTP_STATUS.ERROR) {
      const errorMessage = error?.response?.data?.errors;
      if (errorMessage?.non_field_errors) {
        NotificationManager.error(errorMessage?.non_field_errors[0]);
      } else {
        errorHandler(error)
      }
    }
  })
}

//Select Language GET API

export const selectLanguageAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.SELECT_LANGUAGE
  const options = {
    method: HTTP_METHOD.GET,
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(response => {
    if (response?.status === HTTP_STATUS.SUCCESS || response?.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.SELECT_LANGUAGE_INPUT, payload: response })
      return response
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}

// Update Part Post API

export const updatepartAction = (params = {}, id) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.UPDATE_PART + "/" + id + "/"
  const options = {
    method: HTTP_METHOD.POST,
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === HTTP_STATUS.SUCCESS || resp.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.POST_UPDATE_PART, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    const errorMessage = error?.response?.data?.errors?.non_field_errors[0];
    if (error?.response?.status === HTTP_STATUS.ERROR) {
      NotificationManager.error(errorMessage)
    }
    return error.response
  })
}

// ADD BULK Part Post API
export const addBulkpartAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.ADD_BULK_PART
  const options = {
    method: HTTP_METHOD.POST,
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp?.status === HTTP_STATUS.SUCCESS || resp?.status === HTTP_STATUS.CREATED) {
      dispatch({ type: types.POST_ADD_BULK_PART, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    if (error?.response?.status === HTTP_STATUS.ERROR) {
      const errorMessage = error?.response?.data?.errors?.attachment[0];
      const duplicateError = error?.response?.data;
      if (errorMessage) {
        NotificationManager.error(errorMessage);
      }
      else if (duplicateError) {
        NotificationManager.error(
          duplicateError?.data?.duplicate_part_numbers?.map((item) => (
            <div>{item}</div>
          )),
          duplicateError?.message
        );
      }
    } else {
      errorHandler(error);
    }
    return error?.response;
  })
}
